import { AppDefinition } from '../../types/apps';

export const NeurvanaAppDefinition: AppDefinition = {
  appId: 'neurvana',
  name: 'Neurvana',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Brain',
    phosphorWeight: 'duotone',
    color: '#8b5cf6',
    metadata: {
      source: 'app',
      appId: 'neurvana',
      isAppIcon: true
    }
  },
  description: 'Neuroimaging study management — browse subjects and sessions, run vertex-wise analyses',
  category: 'files',
  version: '0.2.0',
  events: {
    onScanComplete: 'neurvana.scanComplete',
    onFileTagged: 'neurvana.fileTagged',
    onDuplicateFound: 'neurvana.duplicateFound'
  },
  entityTypes: [
    'NeuroProject', 'NeuroSubject', 'NeuroSession', 'NeuroAcquisition', 'NeuroAnalysis',
  ],
  // iconService resolves a Drive/sidebar row's icon from the owning app's
  // entityIcons before falling back to a generic File glyph, so each level needs
  // its own entry here to be visually distinguishable in the tree.
  entityIcons: {
    NeuroProject: {
      type: 'phosphor', phosphorIcon: 'Brain', phosphorWeight: 'duotone', color: '#8b5cf6',
    },
    NeuroSubject: {
      type: 'phosphor', phosphorIcon: 'User', phosphorWeight: 'duotone', color: '#8b5cf6',
    },
    NeuroSession: {
      type: 'phosphor', phosphorIcon: 'CalendarBlank', phosphorWeight: 'duotone', color: '#a78bfa',
    },
    NeuroAcquisition: {
      type: 'phosphor', phosphorIcon: 'Waveform', phosphorWeight: 'duotone', color: '#a78bfa',
    },
    NeuroAnalysis: {
      type: 'phosphor', phosphorIcon: 'ChartScatter', phosphorWeight: 'duotone', color: '#f59e0b',
    },
  },
  component: 'NeurvanaApp',
  requiresProps: false,
  requiresEntity: false,
  supportedFileTypes: ['.nii', '.nii.gz', '.dcm', '.mgh', '.mgz', '.mnc'],
  features: ['studyBrowser', 'scanner', 'tagger', 'duplicateFinder', 'analyses'],
  experimental: true,
};